import { render, staticRenderFns } from "./Third.vue?vue&type=template&id=0c2a99c9&scoped=true&"
import script from "./Third.vue?vue&type=script&lang=js&"
export * from "./Third.vue?vue&type=script&lang=js&"
import style0 from "./Third.vue?vue&type=style&index=0&id=0c2a99c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a99c9",
  null
  
)

export default component.exports